
import { Channels as Base } from '@portable/core/director';

class Channels extends Base {
}

export { Channels };

